import { FontClasses_FontVariantPosition_$ctor_Z207A3CFB, FontClasses_FontVariantLigatures_$ctor_Z207A3CFB, FontClasses_FontVariantEastAsian_$ctor_Z207A3CFB, FontClasses_FontVariantCaps_$ctor_Z207A3CFB, FontClasses_FontVariantNumeric_$ctor_Z207A3CFB, FontClasses_FontFeatureSettings_$ctor_Z207A3CFB, FontClasses_FontFamily_$ctor_Z207A3CFB, FontClasses_LetterSpacing_$ctor_Z207A3CFB, FontClasses_LineBreak_$ctor_Z207A3CFB, FontClasses_LineHeight_$ctor_Z207A3CFB, FontClasses_FontWeight_$ctor_Z207A3CFB, FontClasses_FontStyle_$ctor_Z207A3CFB, FontClasses_FontStretch_$ctor_Z207A3CFB, FontClasses_FontSize_$ctor_Z207A3CFB, FontClasses_FontKerning_$ctor_Z207A3CFB, FontClasses_FontLanguageOverride_$ctor_Z207A3CFB, FontClasses_FontSynthesis_$ctor_Z207A3CFB } from "../Types/Font.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const FontSynthesis = FontClasses_FontSynthesis_$ctor_Z207A3CFB(new Property_CssProperty(115));

export const FontLanguageOverride = FontClasses_FontLanguageOverride_$ctor_Z207A3CFB(new Property_CssProperty(109));

export const FontKerning = FontClasses_FontKerning_$ctor_Z207A3CFB(new Property_CssProperty(108));

export const FontSize = FontClasses_FontSize_$ctor_Z207A3CFB(new Property_CssProperty(111));

export const FontStretch = FontClasses_FontStretch_$ctor_Z207A3CFB(new Property_CssProperty(112));

export const FontStyle = FontClasses_FontStyle_$ctor_Z207A3CFB(new Property_CssProperty(113));

export const FontWeight = FontClasses_FontWeight_$ctor_Z207A3CFB(new Property_CssProperty(123));

export const LineHeight = FontClasses_LineHeight_$ctor_Z207A3CFB(new Property_CssProperty(154));

export const LineBreak = FontClasses_LineBreak_$ctor_Z207A3CFB(new Property_CssProperty(153));

export const LetterSpacing = FontClasses_LetterSpacing_$ctor_Z207A3CFB(new Property_CssProperty(152));

export const FontFamily = FontClasses_FontFamily_$ctor_Z207A3CFB(new Property_CssProperty(107));

export const FontFeatureSettings = FontClasses_FontFeatureSettings_$ctor_Z207A3CFB(new Property_CssProperty(100));

export const FontVariantNumeric = FontClasses_FontVariantNumeric_$ctor_Z207A3CFB(new Property_CssProperty(121));

export const FontVariantCaps = FontClasses_FontVariantCaps_$ctor_Z207A3CFB(new Property_CssProperty(118));

export const FontVariantEastAsian = FontClasses_FontVariantEastAsian_$ctor_Z207A3CFB(new Property_CssProperty(119));

export const FontVariantLigatures = FontClasses_FontVariantLigatures_$ctor_Z207A3CFB(new Property_CssProperty(120));

export const FontVariantPosition = FontClasses_FontVariantPosition_$ctor_Z207A3CFB(new Property_CssProperty(122));

